// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"4327d575","611":"602d0e4b","774":"6431f33f","883":"3ece8255"}[chunkId] + ".chunk.js";
};